// LandingC.jsx — Landing pública de Edge Elite (ruta /).
// Hero dark/moderno + copy apto Meta Ads: posicionado como plataforma de
// ANÁLISIS ESTADÍSTICO / DATOS DEPORTIVOS (sin apuestas, sin casas de apuestas,
// sin promesas de ganancia ni % de aciertos).
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "../../styles/LandingC.css";
import { trackViewContent } from "../../utils/metaPixel";

const EELogo = ({ size = 22, color = "#fff" }) => {
  const dot = Math.round(size * 0.35);
  return (
    <div style={{ fontFamily:'"Inter Tight",-apple-system,"SF Pro Display",system-ui,sans-serif', fontSize:size, fontWeight:700, letterSpacing:"-0.04em", lineHeight:1, color, display:"inline-flex", alignItems:"baseline", whiteSpace:"nowrap" }}>
      Edge Elite
      <span aria-hidden="true" style={{ display:"inline-flex", width:dot, height:dot, marginLeft:Math.round(size*0.08), alignSelf:"flex-end", flex:"none" }}>
        <svg viewBox="0 0 24 24" width={dot} height={dot} fill="none">
          <circle cx="12" cy="12" r="12" fill="#FF4D0D" />
          <path d="M6 6c3.2 2.6 3.2 9.8 0 12" stroke="#0A0A0C" strokeOpacity="0.55" strokeWidth="1.6" strokeLinecap="round" fill="none" />
        </svg>
      </span>
    </div>
  );
};

const WA_FONT = '-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Helvetica,Arial,sans-serif';

// Mensajes del bot reposicionados: proyecciones/confianza, SIN cuotas ni dinero.
const BOT_PICKS = [
  { id:0, type:"pick", league:"NBA",      match:"Denver Nuggets @ Phoenix Suns",     proj:"Total proyectado: 232 · ritmo alto" },
  { id:1, type:"pick", league:"NBA",      match:"Boston Celtics @ Miami Heat",       proj:"Total proyectado: 218 · ritmo alto", green:true },
  { id:2, type:"pick", league:"Euroliga", match:"Valencia Basket @ Olympiacos",      proj:"Total proyectado: 152 · defensa top" },
  { id:3, type:"pick", league:"ACB",      match:"Real Madrid @ FC Barcelona",        proj:"Total proyectado: 161 · ritmo medio" },
  { id:4, type:"pick", league:"NBB",      match:"Flamengo @ Cruzeiro",               proj:"Total proyectado: 173 · ritmo alto", green:true },
  { id:5, type:"pick", league:"NBA",      match:"Los Angeles Lakers @ Golden State Warriors", proj:"Total proyectado: 236 · ritmo alto" },
];

// Ticker: proyección de puntos del motor (no edge de apuesta).
const SIGNALS = [
  { lg:"NBA",      match:"LAL @ GSW", vals:["228","231","229","230"] },
  { lg:"Euroliga", match:"RMB @ FNB", vals:["158","157","159","160"] },
  { lg:"CIBA",     match:"FRO @ CAB", vals:["173","172","174","175"] },
];

// Testimonios sobre la EXPERIENCIA y los datos, sin cifras de dinero ni ROI.
const TESTIS = [
  { name:"Javier Muñoz",  meta:"34 · Santiago · Ing. Civil",   roi:"usa hace 6 sem", when:"hace 2 semanas", text:"Nunca había seguido el básquet con este nivel de datos. Las proyecciones en vivo cambiaron por completo cómo veo los partidos." },
  { name:"Camila Rojas",  meta:"28 · Valparaíso · Diseñadora", roi:"sigue 18 ligas",  when:"hace 5 días",    text:"Sigo solo los análisis de confianza 8+ y la precisión del motor me sorprendió. No es magia, son datos y disciplina.", kind:"chat" },
  { name:"Diego Carvajal",meta:"41 · Concepción · Comerciante",roi:"hace 1 mes",   when:"hace 1 semana",  text:"El dashboard con 94 ligas es lo que más uso. Tener proyecciones de partidos que no aparecen en ningún otro lado no tiene precio." },
];

// Badge de liga para "análisis recientes": {sigla, color}. Fallback = 3 letras + naranja Edge.
function ligaBadge(liga){
  const L = String(liga||"").toLowerCase();
  if(L.includes("nba")) return {sigla:"NBA", c:"linear-gradient(135deg,#FF9A4D,#E84B00)"};
  if(L.includes("euroliga")||L.includes("euroleague")) return {sigla:"EUR", c:"linear-gradient(135deg,#A66BF0,#6A2CC7)"};
  if(L.includes("acb")) return {sigla:"ACB", c:"linear-gradient(135deg,#5BA8FF,#1D4ED8)"};
  if(L.includes("cba")) return {sigla:"CBA", c:"linear-gradient(135deg,#FF6B6B,#C01E1E)"};
  if(L.includes("lega")) return {sigla:"ITA", c:"linear-gradient(135deg,#34D399,#059669)"};
  if(L.includes("nbb")) return {sigla:"NBB", c:"linear-gradient(135deg,#FF77BC,#C01E74)"};
  const s = (String(liga||"?").trim().slice(0,3).toUpperCase()) || "?";
  return {sigla:s, c:"linear-gradient(135deg,#FF6B2C,#BA3600)"};
}

function useIsDesktop() {
  const [d,setD] = useState(typeof window!=="undefined"?window.innerWidth>=860:false);
  useEffect(()=>{ const fn=()=>setD(window.innerWidth>=860); window.addEventListener("resize",fn); return ()=>window.removeEventListener("resize",fn); },[]);
  return d;
}

export default function LandingC() {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();
  const go = (r) => navigate(r==="login"?"/login":"/signup");

  const tgRef = useRef(null);
  const [tgPicks, setTgPicks] = useState(()=>BOT_PICKS.slice(0,5).map((p,i)=>({...p,_uid:i})));
  const [tgNewId, setTgNewId] = useState(-1);
  const [picksToday, setPicksToday] = useState(14);
  const [notifBadge, setNotifBadge] = useState(3);
  const [tgPhoneShake, setTgPhoneShake] = useState(false);
  const [tgVisible, setTgVisible] = useState(false);
  const tgNextIdxRef = useRef(5);

  // Stats REALES desde RTDB /public_stats (lectura pública). Fallback si falla
  // o si recientes viene vacío — nunca rompe la landing.
  const [publicStats, setPublicStats] = useState({ totals:{partidos:3747, ligas:94}, recientes:[] });
  const [logoFail, setLogoFail] = useState(()=>new Set());  // liga_id cuyo logo falló → fallback a badge texto
  // Fecha de hoy (hora Chile) para el título del cuadro — se recalcula en cada render (cambia sola al día siguiente).
  const _MESES_CAP = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
  const _hoyCL = new Date(new Date().toLocaleString("en-US", { timeZone: "America/Santiago" }));
  const fechaHoyTitulo = `${_hoyCL.getDate()} de ${_MESES_CAP[_hoyCL.getMonth()]}`;
  useEffect(()=>{
    const loadStats=()=>{
      fetch("https://mati-edge-elite-default-rtdb.firebaseio.com/public_stats.json")
        .then(r=>r.ok?r.json():null)
        .then(d=>{ if(d && d.totals) setPublicStats({
          totals:{ partidos:Number(d.totals.partidos)||3747, ligas:Number(d.totals.ligas)||94 },
          recientes:Array.isArray(d.recientes)?d.recientes:[],
        }); })
        .catch(()=>{});
    };
    loadStats();                                      // al montar
    const id=setInterval(loadStats, 5*60*1000);       // re-fetch cada 5 min
    return ()=>clearInterval(id);                      // cleanup
  },[]);

  // Meta Pixel: ViewContent al montar la landing.
  useEffect(() => { trackViewContent(); }, []);

  useEffect(()=>{
    if(document.getElementById("ee-landing-anims")) return;
    const s=document.createElement("style"); s.id="ee-landing-anims";
    s.textContent=[
      "@keyframes tgSlideUp{from{opacity:0;transform:translateY(18px) scale(.96)}to{opacity:1;transform:translateY(0) scale(1)}}",
      "@keyframes tgWinGlow{0%{box-shadow:0 0 0 0 rgba(74,222,128,.7)}60%{box-shadow:0 0 0 18px rgba(74,222,128,0)}100%{box-shadow:0 0 0 0 rgba(74,222,128,0)}}",
      "@keyframes tgShake{0%,100%{transform:translateX(0)}20%{transform:translateX(-5px) rotate(-.9deg)}40%{transform:translateX(5px) rotate(.9deg)}60%{transform:translateX(-2px)}80%{transform:translateX(2px)}}",
      "@keyframes tgBadgePop{0%{transform:scale(1)}40%{transform:scale(1.6)}70%{transform:scale(.88)}100%{transform:scale(1)}}",
      "@keyframes tgDot{0%,80%,100%{transform:scale(1);opacity:.35}40%{transform:scale(1.45);opacity:1}}",
      "@keyframes tgGlowPulse{0%,100%{opacity:.45}50%{opacity:1}}",
      "@keyframes romboFloat{0%,100%{transform:rotate(45deg) translateY(0)}50%{transform:rotate(45deg) translateY(-12px)}}",
      "@keyframes liveBlink{0%,100%{opacity:1}50%{opacity:.4}}",
      "@keyframes edgePop{from{color:#FF6B2C;transform:scale(1.18)}to{color:#4ADE80;transform:scale(1)}}"
    ].join(" ");
    document.head.appendChild(s);
  },[]);

  useEffect(()=>{
    if(!tgRef.current) return;
    const io=new IntersectionObserver((e)=>{ if(e[0].isIntersecting) setTgVisible(true); },{threshold:0.15});
    io.observe(tgRef.current); return ()=>io.disconnect();
  },[]);

  useEffect(()=>{
    if(!tgVisible) return;
    const iv=setInterval(()=>{
      const idx=tgNextIdxRef.current;
      const np={...BOT_PICKS[idx%BOT_PICKS.length],_uid:idx};
      setTgPicks(prev=>[...prev.slice(-4),np]);
      tgNextIdxRef.current=idx+1; setTgNewId(idx); setTgPhoneShake(true);
      if(np.type==="pick"){setPicksToday(p=>p+1);setNotifBadge(p=>p+1);}
      setTimeout(()=>setTgNewId(-1),800); setTimeout(()=>setTgPhoneShake(false),420);
    },2700);
    return ()=>clearInterval(iv);
  },[tgVisible]);

  const [edgeIdx,setEdgeIdx]=useState([0,0,0]);
  useEffect(()=>{
    let i=0;
    const t=setInterval(()=>{
      const w=i%3;
      setEdgeIdx(prev=>{const n=[...prev];n[w]=(n[w]+1)%SIGNALS[w].vals.length;return n;});
      i++;
    },1400);
    return ()=>clearInterval(t);
  },[]);

  // Cuenta regresiva del header ("próximo análisis en")
  const [secs, setSecs] = useState(397);
  useEffect(()=>{ const t=setInterval(()=>setSecs(s=>(s>1?s-1:597)),1000); return ()=>clearInterval(t); },[]);
  const mmss = `${String(Math.floor(secs/60)).padStart(2,"0")}:${String(secs%60).padStart(2,"0")}`;

  const Rombo = ({top,bottom,left,right,size=20,bg="linear-gradient(135deg,#FF6B2C,#FF9A6C)",border,opacity=.5,delay="0s",dur="4.8s",radius=4,white=false}) => (
    <div aria-hidden="true" style={{
      position:"absolute",
      ...(top!==undefined?{top}:{}),
      ...(bottom!==undefined?{bottom}:{}),
      ...(left!==undefined?{left}:{}),
      ...(right!==undefined?{right}:{}),
      width:size,height:size,
      background:border?"transparent":(white?bg:bg),
      border:border||"none",
      borderRadius:radius,
      transform:"rotate(45deg)",
      opacity,
      pointerEvents:"none",
      zIndex:1
    }}/>
  );

  return (
    <>
      <Helmet>
        <html lang="es-CL"/>
        <title>Edge Elite · Análisis estadístico deportivo en tiempo real</title>
        <meta name="description" content="Plataforma chilena de análisis estadístico de básquet. Proyecciones y datos en vivo de 94 ligas, directo a tu Telegram. 5 días gratis · $19.990/mes."/>
        <meta name="robots" content="index, follow, max-image-preview:large"/>
        <link rel="canonical" href="https://edgeelite.cl/"/>
        <meta name="theme-color" content="#0A0A0C"/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content="Edge Elite · Análisis estadístico deportivo"/>
        <meta property="og:description" content="Proyecciones y datos en vivo de básquet en 94 ligas, directo a tu Telegram."/>
        <meta property="og:url" content="https://edgeelite.cl/"/>
        <link rel="preconnect" href="https://fonts.googleapis.com"/>
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous"/>
        <link href="https://fonts.googleapis.com/css2?family=Inter+Tight:wght@400;500;600;700;800;900&family=Inter:wght@400;500;600&display=swap" rel="stylesheet"/>

        {/* JSON-LD FAQPage — sincronizado con la sección FAQ visible abajo.
            Google muestra estos como rich results en SERP. */}
        <script type="application/ld+json">{`{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "¿Qué es Edge Elite?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Una plataforma de análisis estadístico deportivo. Nuestro motor cuantitativo procesa partidos de básquet en vivo en más de 90 ligas y calcula proyecciones Over/Under en tiempo real."
      }
    },
    {
      "@type": "Question",
      "name": "¿Edge Elite opera juegos de azar?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No. Somos una herramienta de análisis de datos deportivos. No operamos juego ni retenemos fondos. Te entregamos información estadística; el uso que le des es decisión tuya."
      }
    },
    {
      "@type": "Question",
      "name": "¿Garantizan resultados?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No. Ningún análisis estadístico puede garantizar resultados. Te entregamos una ventaja basada en datos y un método disciplinado, no promesas."
      }
    },
    {
      "@type": "Question",
      "name": "¿Cómo recibo los análisis?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "En tiempo real por Telegram y en tu dashboard web."
      }
    },
    {
      "@type": "Question",
      "name": "¿Cómo funciona la prueba gratis?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Tienes 5 días gratis al suscribirte. Si no es para ti, cancelas antes de que termine y no se te cobra."
      }
    },
    {
      "@type": "Question",
      "name": "¿Necesito experiencia previa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No. Te damos guías y tutoriales para que aproveches el motor desde el primer día."
      }
    }
  ]
}`}</script>

        {/* JSON-LD Organization — entidad oficial Edge Elite para Google
            Knowledge Graph + enlaces de marca. */}
        <script type="application/ld+json">{`{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Edge Elite",
  "alternateName": "EdgeElite",
  "url": "https://edgeelite.cl",
  "logo": "https://edgeelite.cl/logo192.png",
  "description": "Plataforma chilena de análisis estadístico deportivo. Motor cuantitativo Over/Under en básquet sobre 94 ligas en tiempo real.",
  "email": "soporte@edgeelite.cl",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "CL",
    "addressLocality": "Santiago"
  },
  "areaServed": "CL",
  "foundingDate": "2025"
}`}</script>
      </Helmet>

      <div className="ee-root">

        {/* ============================= HERO ============================= */}
        <section style={{position:"relative",overflow:"hidden",color:"#fff",background:"linear-gradient(155deg, #0F0F12 0%, #1A0E08 32%, #3D1606 58%, #8B2B0A 82%, #D44A0F 100%)"}}>
          {/* anillo chico (superior derecha) — en mobile va más abajo para no chocar con los botones */}
          <div aria-hidden="true" style={{position:"absolute",top:isDesktop?80:132,right:20,width:80,height:80,borderRadius:"50%",border:"8px solid rgba(255,255,255,.12)",zIndex:1,pointerEvents:"none"}}/>
          {/* anillo grande (esquina inferior derecha, asomando) */}
          <div aria-hidden="true" style={{position:"absolute",bottom:-40,right:-60,width:220,height:220,borderRadius:"50%",border:"14px solid rgba(255,255,255,.08)",zIndex:1,pointerEvents:"none"}}/>

          {/* Barra de cuenta regresiva */}
          <div style={{position:"relative",zIndex:2,display:"flex",alignItems:"center",justifyContent:"center",gap:10,background:"#000",padding:"8px 12px",fontSize:11,fontWeight:800,letterSpacing:".07em",textTransform:"uppercase"}}>
            <span style={{display:"flex",alignItems:"center",gap:7,color:"#FF7A38"}}>
              <span style={{width:7,height:7,borderRadius:"50%",background:"#dc2626",animation:"liveBlink 1.4s infinite"}}/> Próximo análisis en
            </span>
            <span style={{fontFamily:"ui-monospace,SFMono-Regular,Menlo,monospace",background:"#1c1c20",color:"#fff",borderRadius:7,padding:"3px 9px",letterSpacing:".05em"}}>{mmss}</span>
          </div>

          <div style={{position:"relative",zIndex:2,padding:isDesktop?"18px max(6vw, calc((100% - 1180px) / 2)) 48px":"18px 20px 44px"}}>
            {/* fila superior: logo + botones */}
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:8,marginBottom:isDesktop?34:28}}>
              <EELogo size={isDesktop?28:20} color="#fff"/>
              <div style={{display:"flex",gap:7,flex:"none"}}>
                <button onClick={()=>go("login")} style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:isDesktop?168:"auto",background:"transparent",color:"#fff",border:"1.5px solid rgba(255,255,255,.45)",borderRadius:999,padding:isDesktop?"11px 14px":"8px 12px",fontSize:isDesktop?14:12.5,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>Iniciar sesión</button>
                <button onClick={()=>go("signup")} style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:isDesktop?168:"auto",background:"#fff",color:"#BA3600",border:"1.5px solid #fff",borderRadius:999,padding:isDesktop?"11px 14px":"8px 12px",fontSize:isDesktop?14:12.5,fontWeight:800,cursor:"pointer",whiteSpace:"nowrap"}}>Crear cuenta</button>
              </div>
            </div>

            {/* grid 2 columnas (responsivo) */}
            <div style={{display:"grid",gridTemplateColumns:isDesktop?"1fr 1fr":"1fr",gap:isDesktop?44:40,alignItems:"start"}}>

              {/* IZQUIERDA */}
              <div style={{minWidth:0}}>
                <span style={{display:"inline-flex",alignItems:"center",gap:8,background:"rgba(255,255,255,.06)",border:"1px solid rgba(255,255,255,.12)",color:"#fff",borderRadius:999,padding:"6px 14px",fontSize:11.5,fontWeight:800,letterSpacing:".04em",textTransform:"uppercase"}}>
                  <span style={{width:8,height:8,borderRadius:"50%",background:"#4ADE80"}}/> 12 partidos en vivo
                </span>

                <h1 style={{fontFamily:"var(--font-display)",fontSize:isDesktop?56:44,lineHeight:1.0,letterSpacing:"-.04em",fontWeight:800,margin:isDesktop?"18px 0 16px":"16px 0 14px",color:"#fff"}}>
                  El acceso<br/>que los pros<br/><span style={{color:"#FF8A5C"}}>no comparten.</span>
                </h1>

                <p style={{fontSize:isDesktop?15:15,lineHeight:1.6,color:"rgba(255,255,255,.78)",margin:"0 0 24px",maxWidth:440}}>
                  Un <strong style={{color:"#fff"}}>motor</strong> que analiza básquet en vivo en <strong style={{color:"#fff"}}>94 ligas</strong> y te envía <strong style={{color:"#fff"}}>hasta 15 análisis al día</strong> a <strong style={{color:"#fff"}}>2 grupos VIP de Telegram</strong>. Más <strong style={{color:"#fff"}}>estrategias exclusivas</strong> y tu <strong style={{color:"#fff"}}>Dashboard</strong> en tiempo real.
                </p>

                <div style={{display:"flex",flexDirection:isDesktop?"row":"column",alignItems:isDesktop?"center":"stretch",gap:isDesktop?18:12}}>
                  <button onClick={()=>go("signup")} style={{border:"none",cursor:"pointer",borderRadius:14,padding:"16px 24px",fontSize:16,fontWeight:800,background:"linear-gradient(135deg,#FF6B2C,#E84B00)",color:"#fff",boxShadow:"0 16px 40px rgba(255,107,44,.4)",width:isDesktop?"auto":"100%"}}>Empezar 5 días gratis →</button>
                </div>

                <div style={{display:"flex",flexWrap:"wrap",gap:isDesktop?18:14,marginTop:14}}>
                  {["Acceso inmediato","Sin permanencia","Cancelas en 1 clic"].map(t=>(
                    <span key={t} style={{display:"inline-flex",alignItems:"center",gap:6,fontSize:12.5,fontWeight:600,color:"rgba(255,255,255,.78)"}}><span style={{color:"#4ADE80",fontWeight:800}}>✓</span> {t}</span>
                  ))}
                </div>

                <div style={{fontSize:12.5,color:"rgba(255,255,255,.55)",marginTop:12,lineHeight:1.5}}>🔥 Lanzamiento: $19.990/mes <span style={{textDecoration:"line-through",opacity:.7}}>$29.990</span> · 5 días gratis solo con suscripción</div>

                <div style={{display:"flex",alignItems:"center",gap:12,marginTop:24}}>
                  <div style={{display:"flex"}}>
                    {[["J","#4285F4"],["C","#DB4437"],["M","#0F9D58"],["A","#F4B400"],["S","#AB47BC"]].map(([l,c],i)=>(
                      <div key={l} style={{width:32,height:32,borderRadius:"50%",background:c,color:"#fff",fontSize:13,fontWeight:600,fontFamily:"var(--font-display)",display:"flex",alignItems:"center",justifyContent:"center",border:"2px solid #1a0f0a",marginLeft:i?-14:0}}>{l}</div>
                    ))}
                  </div>
                  <span style={{flex:1,minWidth:0,fontSize:13,fontWeight:700,color:"rgba(255,255,255,.8)"}}>Javier Muñoz, Camila Rojas <span style={{color:"rgba(255,255,255,.55)",fontWeight:600}}>y 18 más</span></span>
                </div>
              </div>

              {/* DERECHA */}
              <div style={{position:"relative",display:"flex",flexDirection:"column",gap:14,width:"100%",maxWidth:"none",marginLeft:0,minWidth:0}}>
                {isDesktop && (
                  <>
                    <Rombo top={-16} left={-20} size={18} bg="linear-gradient(135deg,#FF6B2C,#FF9A6C)" opacity={.55} dur="4.6s" delay="0s"   radius={4}/>
                    <Rombo top={34}  right={-22} size={13} border="2px solid rgba(255,138,60,.55)"      opacity={.6}  dur="4.1s" delay="0.5s" radius={2}/>
                    <Rombo top="46%" left={-24} size={10} bg="rgba(255,138,60,.5)"                      opacity={.6}  dur="3.8s" delay="0.3s" radius={2}/>
                    <Rombo top="42%" right={-38} size={22} bg="linear-gradient(135deg,#BA3600,#FF6B2C)" opacity={.4}  dur="5.5s" delay="0.8s" radius={5}/>
                    <Rombo bottom={44} left={-18} size={12} border="1.5px solid rgba(255,138,60,.5)"    opacity={.55} dur="4.4s" delay="0.7s" radius={2}/>
                    <Rombo bottom={-14} right={-16} size={16} bg="rgba(255,138,60,.45)"                  opacity={.5}  dur="5.0s" delay="1.1s" radius={3}/>
                    <Rombo top={-12} right="38%" size={8}  bg="rgba(255,138,60,.5)"                      opacity={.55} dur="4.2s" delay="0.2s" radius={2}/>
                    <Rombo bottom={-10} left="34%" size={9} border="1.5px solid rgba(255,138,60,.5)"     opacity={.5}  dur="4.7s" delay="1.3s" radius={2}/>
                  </>
                )}
                {/* Análisis recientes — data REAL desde /public_stats */}
                <div style={{background:"rgba(20,18,22,.72)",border:"1px solid rgba(255,255,255,.08)",borderRadius:22,padding:"16px 18px",backdropFilter:"blur(8px)"}}>
                  <div style={{display:"flex",alignItems:"center",marginBottom:8}}>
                    <span style={{display:"flex",alignItems:"center",gap:7,fontSize:11.5,fontWeight:800,letterSpacing:".06em",color:"rgba(255,255,255,.9)",minWidth:0}}><span style={{width:7,height:7,borderRadius:"50%",background:"#4ADE80",animation:"liveBlink 1.6s infinite",flexShrink:0}}/> ÚLTIMOS ANÁLISIS DE HOY ENVIADOS · {fechaHoyTitulo}</span>
                  </div>
                  {publicStats.recientes.map((s,i)=>{
                    const b=ligaBadge(s.liga);
                    const win=s.result==="WIN";
                    const lineStr=String(s.line);
                    const showLogo=s.liga_id && !logoFail.has(s.liga_id);
                    const dirOver=s.dir==="OVER";
                    const icon=isDesktop?40:36;
                    const sub=s.pais?`${s.liga} · ${s.pais}`:s.liga;
                    const pillBase={borderRadius:8,fontWeight:700,whiteSpace:"nowrap",boxSizing:"border-box",flexShrink:0,display:"inline-flex",alignItems:"center",justifyContent:"center"};
                    const dirPill={...pillBase,
                      background:dirOver?"rgba(216,90,48,.18)":"rgba(30,64,175,.22)",
                      border:dirOver?"1px solid rgba(216,90,48,.5)":"1px solid rgba(59,130,246,.5)",
                      color:dirOver?"#F0997B":"#93B4F4"};
                    const resPill={...pillBase,
                      background:win?"rgba(22,163,74,.16)":"rgba(220,38,38,.16)",
                      border:win?"1px solid rgba(22,163,74,.45)":"1px solid rgba(220,38,38,.45)",
                      color:win?"#22c55e":"#f87171"};
                    const iconEl = showLogo ? (
                      <img src={`https://media.api-sports.io/basketball/leagues/${s.liga_id}.png`} alt={s.liga} width={icon} height={icon}
                        onError={()=>setLogoFail(prev=>{const n=new Set(prev);n.add(s.liga_id);return n;})}
                        style={{width:icon,height:icon,borderRadius:10,objectFit:"contain",background:"rgba(255,255,255,.06)",padding:3,flex:"none",border:"1px solid rgba(255,255,255,.1)"}}/>
                    ) : (
                      <div style={{width:icon,height:icon,borderRadius:10,background:b.c,display:"flex",alignItems:"center",justifyContent:"center",fontSize:isDesktop?10:9.5,fontWeight:800,color:"#fff",flex:"none",boxShadow:"0 4px 12px rgba(0,0,0,.3)",border:"1px solid rgba(255,255,255,.14)"}}>{b.sigla}</div>
                    );
                    return isDesktop ? (
                    <div key={i} style={{display:"flex",alignItems:"center",gap:13,padding:"9px 0",borderTop:i?"1px solid rgba(255,255,255,.06)":"none"}}>
                      {iconEl}
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontSize:14,fontWeight:800,color:"#fff",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{s.away} vs {s.home}</div>
                        <div style={{fontSize:12,color:"#FF8A50",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{sub}</div>
                      </div>
                      <div style={{display:"flex",gap:7,flexShrink:0,alignItems:"center"}}>
                        <span style={{...dirPill,width:104,fontSize:12,padding:"6px 0"}}>{s.dir} {lineStr}</span>
                        <span style={{...resPill,width:96,fontSize:12,padding:"6px 0"}}>{win?"✓ GANÓ":"✗ PERDIÓ"}</span>
                      </div>
                    </div>
                    ) : (
                    <div key={i} style={{display:"flex",alignItems:"center",gap:9,padding:"9px 0",borderTop:i?"1px solid rgba(255,255,255,.06)":"none"}}>
                      {iconEl}
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontSize:13,fontWeight:800,color:"#fff",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{s.away} vs {s.home}</div>
                        <div style={{fontSize:11,color:"#FF8A50",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",marginBottom:5}}>{sub}</div>
                        <span style={{...dirPill,display:"inline-block",textAlign:"center",fontSize:11,padding:"3px 8px"}}>{s.dir} {lineStr}</span>
                      </div>
                      <span style={{...resPill,width:84,alignSelf:"center",fontSize:11,padding:"5px 0"}}>{win?"✓ GANÓ":"✗ PERDIÓ"}</span>
                    </div>
                    );
                  })}
                  {!isDesktop && (
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:10,background:"rgba(255,107,44,.08)",border:"1px solid rgba(255,107,44,.2)",borderRadius:14,padding:"12px 14px"}}>
                    <div>
                      <div style={{fontSize:10,fontWeight:800,letterSpacing:".06em",color:"#FF8A5C",textTransform:"uppercase"}}>Próximo análisis</div>
                      <div style={{fontSize:14,fontWeight:800,color:"#fff",marginTop:2}}>en {mmss}</div>
                    </div>
                    <span style={{display:"flex",alignItems:"center",gap:6,background:"rgba(220,38,38,.16)",color:"#ff7a6b",borderRadius:999,padding:"6px 12px",fontSize:11,fontWeight:800}}><span style={{width:6,height:6,borderRadius:"50%",background:"#dc2626",animation:"liveBlink 1.4s infinite"}}/> EN VIVO</span>
                  </div>
                  )}
                  <div style={{fontSize:11.5,color:"#8a817c",marginTop:4,paddingTop:10,borderTop:"1px solid rgba(255,255,255,.05)",display:"flex",alignItems:"center",gap:5}}>🔄 Resultados actualizados cada hora</div>
                </div>

                {/* Actividad del motor (sin claim de precisión, apto Meta) */}
                <div style={{background:"linear-gradient(135deg,rgba(255,255,255,.08),rgba(255,255,255,.02))",border:"1px solid rgba(255,255,255,.1)",borderRadius:20,padding:"16px 18px"}}>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8}}>
                    <span style={{fontSize:10,fontWeight:800,letterSpacing:".06em",color:"rgba(255,255,255,.6)",textTransform:"uppercase"}}>Partidos analizados por el motor</span>
                    <span style={{display:"inline-flex",alignItems:"center",gap:5,background:"rgba(74,222,128,.14)",color:"#4ADE80",borderRadius:999,padding:"3px 9px",fontSize:9.5,fontWeight:800,letterSpacing:".04em"}}><span style={{width:6,height:6,borderRadius:"50%",background:"#4ADE80"}}/> EN VIVO</span>
                  </div>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12}}>
                    <div style={{flex:"none"}}>
                      <div style={{display:"flex",alignItems:"baseline",gap:4}}>
                        <span style={{fontSize:40,fontWeight:900,letterSpacing:"-.02em",lineHeight:1,background:"linear-gradient(135deg,#fff,#FFCBA6)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>{publicStats.totals.partidos.toLocaleString("es-CL")}</span>
                        <span style={{fontSize:14,fontWeight:700,color:"rgba(255,255,255,.55)"}}>partidos</span>
                      </div>
                      <span style={{display:"inline-flex",alignItems:"center",gap:4,background:"rgba(255,255,255,.07)",color:"rgba(255,255,255,.82)",borderRadius:999,padding:"3px 9px",fontSize:11,fontWeight:700,marginTop:8}}>🌐 {publicStats.totals.ligas} ligas cubiertas</span>
                    </div>
                    <svg width="170" height="62" viewBox="0 0 170 62" style={{display:"block",flex:"none",maxWidth:"55%"}}>
                      <defs>
                        <linearGradient id="precFill" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="#4ADE80" stopOpacity=".28"/>
                          <stop offset="100%" stopColor="#4ADE80" stopOpacity="0"/>
                        </linearGradient>
                      </defs>
                      <path d="M0,48 L24,46 L48,47 L71,40 L95,34 L119,25 L143,16 L168,8 L168,62 L0,62 Z" fill="url(#precFill)"/>
                      <path d="M0,48 L24,46 L48,47 L71,40 L95,34 L119,25 L143,16 L168,8" fill="none" stroke="#4ADE80" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="168" cy="8" r="3.5" fill="#4ADE80"/>
                    </svg>
                  </div>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:8,marginTop:12,paddingTop:12,borderTop:"1px solid rgba(255,255,255,.07)"}}>
                    <span style={{fontSize:11,color:"rgba(255,255,255,.6)"}}>🛡 Resultados verificables</span>
                    <span style={{display:"inline-flex",alignItems:"center",gap:5,fontSize:10.5,color:"rgba(255,255,255,.5)",whiteSpace:"nowrap"}}><span style={{width:6,height:6,borderRadius:"50%",background:"#4ADE80"}}/> actualizado cada hora</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* ============================= BOT EN ACCIÓN ============================= */}
        <section className="ee-sec ee-sec--gray ee-sec--bot" ref={tgRef}>
          <Rombo top={18}   left={-10} size={22} bg="linear-gradient(135deg,#FF6B2C,#FF9A6C)" opacity={.5}  dur="4.5s" delay="0s"  radius={4}/>
          <Rombo top={60}   right={-8} size={16} border="2px solid rgba(255,107,44,.55)"      opacity={.7}  dur="3.9s" delay="0.4s" radius={3}/>
          <Rombo bottom={80}  left={-6}  size={30} bg="linear-gradient(135deg,#BA3600,#FF6B2C)" opacity={.4} dur="5.7s" delay="0.8s" radius={6}/>
          <Rombo bottom={40}  right={-4} size={18} bg="rgba(255,107,44,.35)"                   opacity={.6} dur="5.0s" delay="1.2s" radius={3}/>
          <Rombo top="45%"  left={-4}  size={10} bg="rgba(255,107,44,.5)"                    opacity={.8} dur="3.5s" delay="0.6s" radius={2}/>
          <Rombo top="30%"  right={-5} size={12} bg="linear-gradient(135deg,#FF6B2C,#BA3600)" opacity={.55} dur="5.5s" delay="1.5s" radius={2}/>

          {/* Rombos extra: SOLO desktop (~16 distribuidos) */}
          <div className="ee-bot-rombos-desktop" aria-hidden="true">
            <Rombo top={48}   left="14%" size={14} border="2px solid rgba(255,107,44,.55)" opacity={.75} dur="3.9s" delay="0.3s" radius={3}/>
            <Rombo top={130}  left="6%"  size={26} bg="linear-gradient(135deg,#BA3600,#FF6B2C)" opacity={.42} dur="5.7s" delay="0.7s" radius={5}/>
            <Rombo top={200}  left="20%" size={10} bg="rgba(255,107,44,.55)" opacity={.8} dur="3.5s" delay="0.5s" radius={2}/>
            <Rombo top={280}  left="3%"  size={18} bg="rgba(255,107,44,.35)" opacity={.6} dur="4.8s" delay="1.0s" radius={3}/>
            <Rombo bottom={130} left="10%" size={22} bg="linear-gradient(135deg,#FF6B2C,#FF9A6C)" opacity={.5} dur="5.2s" delay="0.2s" radius={4}/>
            <Rombo bottom={180} left="22%" size={12} border="2px solid rgba(255,107,44,.5)" opacity={.7} dur="4.1s" delay="1.2s" radius={2}/>
            <Rombo bottom={240} left="34%" size={16} bg="linear-gradient(135deg,#FF6B2C,#BA3600)" opacity={.5} dur="4.9s" delay="0.8s" radius={3}/>
            <Rombo top={36}   right="10%" size={20} bg="linear-gradient(135deg,#FF6B2C,#FF9A6C)" opacity={.55} dur="4.6s" delay="0.4s" radius={4}/>
            <Rombo top={100}  right="24%" size={12} border="2px solid rgba(255,107,44,.55)" opacity={.7} dur="3.8s" delay="1.1s" radius={2}/>
            <Rombo top={250}  right="30%" size={10} bg="rgba(255,107,44,.6)" opacity={.8} dur="3.6s" delay="0.1s" radius={2}/>
            <Rombo bottom={120} right="16%" size={22} bg="linear-gradient(135deg,#FF6B2C,#FF9A6C)" opacity={.5} dur="5.3s" delay="0.9s" radius={4}/>
            <Rombo bottom={200} right="28%" size={14} bg="rgba(255,107,44,.4)" opacity={.65} dur="4.8s" delay="0.5s" radius={2}/>
            <Rombo top="50%" left="40%" size={9} bg="rgba(255,107,44,.55)" opacity={.7} dur="3.5s" delay="0.7s" radius={2}/>
            <Rombo top="30%" left="48%" size={8} border="1.5px solid rgba(255,107,44,.5)" opacity={.6} dur="4.2s" delay="1.4s" radius={1}/>
            <Rombo bottom="35%" left="46%" size={11} bg="rgba(255,107,44,.5)" opacity={.65} dur="3.9s" delay="0.4s" radius={2}/>
            <Rombo top={14}  left="50%" size={8} bg="linear-gradient(135deg,#FF6B2C,#FF9A6C)" opacity={.6} dur="4.6s" delay="0.2s" radius={2}/>
          </div>

          <div className="ee-sec-inner">
            <div className="ee-bot-grid">
              <div className="ee-bot-left">
                <div className="ee-eyebrow-pill">⚡ Motor en acción</div>
                <h2 className="ee-h2">El motor te escribe<br className="ee-br-mobile"/> directo a Telegram</h2>

                <div className="ee-stats-row">
                  <div className="ee-stat-card">
                    <span className="ee-stat-dot"/>
                    <div className="ee-stat-lbl">Motor activo</div>
                  </div>
                  <div className="ee-stat-card">
                    <div className="ee-stat-num" style={{color:"#FF6B2C"}}>{picksToday}</div>
                    <div className="ee-stat-sub">análisis hoy</div>
                  </div>
                  <div className="ee-stat-card">
                    <div className="ee-stat-num" style={{color:"#16A34A"}}>{publicStats.totals.ligas}</div>
                    <div className="ee-stat-sub">ligas</div>
                  </div>
                </div>
              </div>

              <div className="ee-bot-right">
                <div className="ee-phone-wrap">
                  <div aria-hidden="true" className="ee-phone-aura"/>
                  <div aria-hidden="true" className="ee-phone-aura-mid"/>
                  <Rombo top={-12} left={-18} size={16} bg="linear-gradient(135deg,#FF6B2C,#FF9A6C)" opacity={1} dur="4.2s" delay="0s"  radius={3}/>
                  <Rombo bottom={10} right={-20} size={22} bg="linear-gradient(135deg,#BA3600,#FF6B2C)" opacity={1} dur="5.3s" delay="0.7s" radius={4}/>

                  <div className="ee-notif-badge" key={"nb"+notifBadge}>{Math.min(notifBadge,99)}</div>

                  <div className={"ee-phone"+(tgPhoneShake?" ee-phone--shake":"")}>
                    <div className="ee-phone-notch"/>
                    <div className="ee-phone-screen">
                      <div className="ee-phone-header">
                        <div className="ee-phone-avatar">⚡</div>
                        <div className="ee-phone-info">
                          <div className="ee-phone-name">Edge Elite Bot</div>
                          <div className="ee-phone-status"><span className="ee-phone-status-dot"/> en línea · enviando análisis</div>
                        </div>
                      </div>

                      <div className="ee-phone-msgs">
                        {tgPicks.map(p=>(
                          <div key={p._uid} className={"ee-phone-msg "+(p.green?"ee-phone-msg--win":"ee-phone-msg--pick")} style={p._uid===tgNewId?{animation:"tgSlideUp .55s ease-out"}:{}}>
                            {p.type==="win"?(
                              <div className="ee-phone-msg-row-top">
                                <div>
                                  <div className="ee-msg-tag ee-msg-tag--win">✓ PROYECCIÓN ACERTADA</div>
                                  <div className="ee-msg-match">{p.league} · {p.match}</div>
                                  <div className="ee-msg-sub">Racha {p.streak} ✓</div>
                                </div>
                              </div>
                            ):(
                              <>
                                <div className="ee-phone-msg-row-top">
                                  <div className={"ee-msg-tag "+(p.green?"ee-msg-tag--win":"ee-msg-tag--pick")}>📊 ANÁLISIS EN VIVO</div>
                                </div>
                                <div className="ee-msg-match">{p.league} · {p.match}</div>
                                <div className="ee-msg-sub">{p.proj}</div>
                              </>
                            )}
                          </div>
                        ))}
                      </div>

                      <div className="ee-phone-footer">
                        <div className="ee-phone-input"><span>Mensaje</span></div>
                        <div className="ee-phone-send">→</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ee-phone-caption">Conectas el bot en 30 segundos · Sin spam</div>
              </div>
            </div>
          </div>
        </section>

        {/* ============================= CÓMO FUNCIONA ============================= */}
        <section className="ee-sec ee-sec--white ee-sec--howto" id="como-funciona">
          <Rombo top={14}   left={-7} size={18} bg="linear-gradient(135deg,#FF6B2C,#FF9A6C)" opacity={.5}  dur="4.6s" delay="0.2s" radius={3}/>
          <Rombo bottom={20} right={-6} size={26} bg="linear-gradient(135deg,#BA3600,#FF6B2C)" opacity={.4} dur="6.2s" delay="0.9s" radius={5}/>

          <div className="ee-sec-inner">
            <div className="ee-howto-grid">
              <div className="ee-howto-left">
                <div className="ee-eyebrow-pill">📋 Cómo funciona</div>
                <h2 className="ee-h2">Tres pasos.<br className="ee-br-mobile"/> Sin complicaciones.</h2>
              </div>

              <div className="ee-howto-right">
                <div className="ee-steps">
                  <div className="ee-step">
                    <div className="ee-step-col">
                      <div className="ee-step-num">1</div>
                      <div className="ee-step-line"/>
                    </div>
                    <div className="ee-step-content">
                      <div className="ee-step-title">Crea tu cuenta</div>
                      <div className="ee-step-card">
                        <p className="ee-step-text">Con <strong>suscripción automática</strong>: 5 días gratis y luego <strong>$19.990/mes</strong> (cancela cuando quieras). ¿Prefieres otro medio de pago? Pagas <strong>$19.990</strong> y entras al instante, sin período de prueba.</p>
                        <span className="ee-step-badge">🎁 5 días gratis solo con suscripción</span>
                      </div>
                    </div>
                  </div>
                  <div className="ee-step">
                    <div className="ee-step-col">
                      <div className="ee-step-num">2</div>
                      <div className="ee-step-line"/>
                    </div>
                    <div className="ee-step-content">
                      <div className="ee-step-title">Conecta Telegram + Dashboard</div>
                      <div className="ee-step-card">
                        <p className="ee-step-text">Un clic. El motor queda listo en 30 segundos y accedes a tu <strong>Dashboard</strong> con análisis en tiempo real.</p>
                        <div className="ee-step-grid">
                          <div className="ee-step-mini ee-step-mini--o"><div className="ee-step-mini-ic">⚡</div><div className="ee-step-mini-t">Bot Análisis</div><div className="ee-step-mini-s">Directo a Telegram</div></div>
                          <div className="ee-step-mini ee-step-mini--g"><div className="ee-step-mini-ic">📊</div><div className="ee-step-mini-t">Dashboard</div><div className="ee-step-mini-s">Web + datos</div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ee-step ee-step--last">
                    <div className="ee-step-col">
                      <div className="ee-step-num ee-step-num--final">3</div>
                    </div>
                    <div className="ee-step-content">
                      <div className="ee-step-title">El motor trabaja por ti</div>
                      <div className="ee-step-card ee-step-card--accent">
                        <p className="ee-step-text">Recibes <strong style={{color:"#FF6B2C"}}>hasta 15 análisis al día</strong> con proyección, confianza y los datos clave del partido.</p>
                        <div className="ee-step-tags">
                          <span className="ee-step-tag">Proyección</span>
                          <span className="ee-step-tag">Confianza</span>
                          <span className="ee-step-tag">Liga + partido</span>
                          <span className="ee-step-tag">Datos en vivo</span>
                          <span className="ee-step-tag">Dashboard 24/7</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ============================= TU DASHBOARD ============================= */}
        <section className="ee-sec ee-sec--gray">
          <Rombo top={20}    right={-8}  size={24} bg="linear-gradient(135deg,#FF6B2C,#FF9A6C)" opacity={.45} dur="4.9s" delay="0s"   radius={4}/>
          <Rombo bottom={60}   left={-8}   size={32} bg="linear-gradient(135deg,#BA3600,#FF6B2C)" opacity={.35} dur="5.9s" delay="1.0s" radius={6}/>

          <div className="ee-sec-inner">
            <div className="ee-eyebrow">Incluido en tu suscripción</div>
            <h2 className="ee-h2-alt">Tu Dashboard.<br className="ee-br-mobile"/> Decide con datos.</h2>
            <p className="ee-sec-lead">Además de los análisis en Telegram, tienes acceso a un Dashboard completo para seguir cada partido con datos en tiempo real.</p>

            <div className="ee-features">
              {[
                {icon:"📊",bg:"linear-gradient(135deg,#FF6B2C,#BA3600)",title:"Análisis en tiempo real",text:"Todos los partidos con proyecciones y probabilidades del motor actualizándose en vivo."},
                {icon:"⚡",bg:"linear-gradient(135deg,#1D4ED8,#1E3A8A)",title:"Análisis del motor en vivo",text:"Cada partido con detalle completo: proyección, confianza, ligas y tendencias."},
                {icon:"🎯",bg:"linear-gradient(135deg,#16A34A,#14532D)",title:"Historial y precisión",text:"Precisión del motor, histórico y tendencias. Transparencia total."},
                {icon:"🌐",bg:"linear-gradient(135deg,#7C3AED,#4C1D95)",title:"94 ligas del mundo",text:"NBA, Euroliga, ACB, NBB, CIBA y más. Filtra por liga y nivel de confianza."},
              ].map((f,i)=>(
                <div key={i} className="ee-feature">
                  <div className="ee-feature-ic" style={{background:f.bg}} aria-hidden="true">{f.icon}</div>
                  <div>
                    <div className="ee-feature-t">{f.title}</div>
                    <div className="ee-feature-p">{f.text}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="ee-banner-cta">
              <div>
                <div className="ee-banner-cta-t">Bot + Dashboard incluidos</div>
                <div className="ee-banner-cta-s">5 días gratis con suscripción · o $19.990 con acceso inmediato.</div>
              </div>
              <button className="ee-banner-cta-btn" onClick={()=>go("signup")}>Probar gratis →</button>
            </div>
          </div>
        </section>

        {/* ============================= STATS ============================= */}
        <section className="ee-stats" id="precision">
          <div className="ee-eyebrow ee-eyebrow--dark">El motor en números</div>
          <div className="ee-stats-big">
            <span className="ee-stats-num">{publicStats.totals.partidos.toLocaleString("es-CL")}</span>
          </div>
          <div className="ee-stats-caption">partidos analizados · {publicStats.totals.ligas} ligas cubiertas</div>
        </section>

        {/* ============================= PRICING ============================= */}
        <section className="ee-sec ee-sec--white" id="precios">
          <Rombo top={16}    right={-6} size={20} bg="linear-gradient(135deg,#FF6B2C,#FF9A6C)" opacity={.5}  dur="4.8s" delay="0s"   radius={4}/>
          <Rombo bottom={40}   left={-7} size={28} bg="linear-gradient(135deg,#BA3600,#FF6B2C)" opacity={.4}  dur="5.6s" delay="1.4s" radius={5}/>

          <div className="ee-sec-inner">
            <div className="ee-eyebrow ee-eyebrow--center">Precio</div>
            <h2 className="ee-h2 ee-h2--center">Simple.<br className="ee-br-mobile"/> Sin sorpresas.</h2>
            <p className="ee-sec-lead ee-sec-lead--center">Un solo plan, dos formas de entrar.<br/>5 días gratis con suscripción · o pago directo con acceso inmediato.</p>

            <div className="ee-pricing-card">
              <div aria-hidden="true" className="ee-pricing-glow"/>
              <div className="ee-pricing-badge-wrap">
                <span className="ee-pricing-badge">🔥 Oferta de lanzamiento</span>
              </div>
              <div className="ee-pricing-num-wrap" style={{display:"flex",alignItems:"baseline",justifyContent:"center",gap:10}}>
                <span style={{fontSize:18,color:"#B7A498",textDecoration:"line-through",fontWeight:700}}>$29.990</span>
                <span className="ee-pricing-num">$19.990</span><span className="ee-pricing-unit">/mes</span>
              </div>
              <div className="ee-pricing-sub">Precio de lanzamiento · Plan mensual · Cancela cuando quieras</div>

              <div className="ee-pricing-divider"/>
              <div style={{margin:"4px 0 6px",display:"flex",flexDirection:"column",gap:13}}>
                <div style={{display:"flex",gap:11,alignItems:"flex-start",textAlign:"left"}}>
                  <span style={{flex:"none",width:30,height:30,borderRadius:9,background:"rgba(255,107,44,.12)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:15}}>🔄</span>
                  <div>
                    <div style={{fontSize:13.5,fontWeight:700,color:"#1D1D1F"}}>Suscripción automática</div>
                    <div style={{fontSize:12.5,color:"#6E6E73",lineHeight:1.5,marginTop:2}}>5 días gratis, luego $19.990/mes. Se renueva sola y cancelas cuando quieras.</div>
                  </div>
                </div>
                <div style={{display:"flex",gap:11,alignItems:"flex-start",textAlign:"left"}}>
                  <span style={{flex:"none",width:30,height:30,borderRadius:9,background:"rgba(29,78,216,.10)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:15}}>💳</span>
                  <div>
                    <div style={{fontSize:13.5,fontWeight:700,color:"#1D1D1F"}}>Otros medios de pago</div>
                    <div style={{fontSize:12.5,color:"#6E6E73",lineHeight:1.5,marginTop:2}}>Pagas $19.990 y entras al instante, sin período de prueba ni renovación.</div>
                  </div>
                </div>
              </div>

              <div className="ee-pricing-divider"/>
              <div className="ee-pricing-feats">
                {[
                  {icon:"⚡",text:"Hasta 15 análisis al día directo a Telegram"},
                  {icon:"📊",text:"Dashboard completo con todos los partidos"},
                  {icon:"🌐",text:"94 ligas · NBA, Euroliga, ACB y más"},
                  {icon:"🎯",text:"Proyección, confianza y datos del partido"},
                  {icon:"✓",text:"Sin permanencia · Cancela en 1 clic", green:true},
                ].map((f,i)=>(
                  <div key={i} className="ee-pricing-feat">
                    <div className={"ee-pricing-feat-ic"+(f.green?" ee-pricing-feat-ic--g":"")}>{f.icon}</div>
                    <span>{f.text}</span>
                  </div>
                ))}
              </div>
              <button className="ee-pricing-btn" onClick={()=>go("signup")}>Empezar 5 días gratis →</button>
              <div className="ee-pricing-secure">Pago seguro · Flow.cl · Sin cargos ocultos</div>
            </div>
          </div>
        </section>

        {/* ============================= TESTIMONIOS ============================= */}
        <section className="ee-sec ee-sec--gray">
          <div className="ee-sec-inner">
            <div className="ee-eyebrow">De usuarios reales</div>
            <h2 className="ee-h2-alt">+100 usuarios activos</h2>
            <p className="ee-sec-lead">Verificados vía WhatsApp · publicados con permiso</p>

            <div className="ee-testis">
              {TESTIS.map((t,i)=>(
                <div key={i} className="ee-testi">
                  <div className="ee-testi-head">
                    <div className="ee-testi-av">{t.name.charAt(0)}</div>
                    <div className="ee-testi-info">
                      <div className="ee-testi-name">{t.name} <span className="ee-testi-verif">✓ Verificado</span></div>
                      <div className="ee-testi-meta">{t.meta}</div>
                    </div>
                    <div className="ee-testi-roi">
                      <span className="ee-testi-roi-bar">{t.roi}</span>
                      <span className="ee-testi-roi-when">{t.when}</span>
                    </div>
                  </div>
                  {t.kind==="chat"?(
                    <div className="ee-testi-wa">
                      <div className="ee-testi-wa-out" style={{fontFamily:WA_FONT}}>{t.text}<div className="ee-testi-wa-time">14:22 ✓✓</div></div>
                      <div className="ee-testi-wa-in" style={{fontFamily:WA_FONT}}>Gracias Camila 🙌 Vamos por más.<div className="ee-testi-wa-time">14:24</div></div>
                    </div>
                  ):(
                    <div className="ee-testi-text">{t.text}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ============================= CTA FINAL ============================= */}
        <section className="ee-cta-final-wrap">
          <div className="ee-cta-final">
            <div className="ee-cta-final-h">Tu primer análisis llega hoy.</div>
            <div className="ee-cta-final-p">🔥 Lanzamiento $19.990/mes (antes $29.990) · 5 días gratis solo con suscripción</div>
            <button className="ee-cta-final-btn" onClick={()=>go("signup")}>Empezar 5 días gratis →</button>
          </div>
        </section>

        {/* ============================= FAQ ============================= */}
        {/* Sección nueva (FASE 3 SEO). El JSON-LD FAQPage en <Helmet> arriba
            está sincronizado palabra por palabra con estas preguntas. */}
        <section className="ee-faq">
          <div className="ee-faq-wrap">
            <div className="ee-faq-eyebrow">FAQ</div>
            <h2 className="ee-faq-h">Preguntas frecuentes</h2>
            <p className="ee-faq-sub">Todo lo que tienes que saber antes de empezar.</p>

            <div className="ee-faq-list">
              <details className="ee-faq-item">
                <summary className="ee-faq-q">¿Qué es Edge Elite?</summary>
                <p className="ee-faq-a">
                  Una plataforma de análisis estadístico deportivo. Nuestro motor cuantitativo procesa
                  partidos de básquet en vivo en más de 90 ligas y calcula proyecciones Over/Under
                  en tiempo real.
                </p>
              </details>
              <details className="ee-faq-item">
                <summary className="ee-faq-q">¿Edge Elite opera juegos de azar?</summary>
                <p className="ee-faq-a">
                  No. Somos una herramienta de análisis de datos deportivos. No operamos juego ni
                  retenemos fondos. Te entregamos información estadística; el uso que le des es
                  decisión tuya.
                </p>
              </details>
              <details className="ee-faq-item">
                <summary className="ee-faq-q">¿Garantizan resultados?</summary>
                <p className="ee-faq-a">
                  No. Ningún análisis estadístico puede garantizar resultados. Te entregamos una
                  ventaja basada en datos y un método disciplinado, no promesas.
                </p>
              </details>
              <details className="ee-faq-item">
                <summary className="ee-faq-q">¿Cómo recibo los análisis?</summary>
                <p className="ee-faq-a">
                  En tiempo real por Telegram y en tu dashboard web.
                </p>
              </details>
              <details className="ee-faq-item">
                <summary className="ee-faq-q">¿Cómo funciona la prueba gratis?</summary>
                <p className="ee-faq-a">
                  Tienes 5 días gratis al suscribirte. Si no es para ti, cancelas antes de que
                  termine y no se te cobra.
                </p>
              </details>
              <details className="ee-faq-item">
                <summary className="ee-faq-q">¿Necesito experiencia previa?</summary>
                <p className="ee-faq-a">
                  No. Te damos guías y tutoriales para que aproveches el motor desde el primer día.
                </p>
              </details>
            </div>
          </div>

          <style>{`
            .ee-faq {
              background: #0A0A0C;
              color: #fff;
              padding: 64px 20px 72px;
              border-top: 1px solid rgba(255,255,255,.06);
            }
            .ee-faq-wrap {
              max-width: 800px;
              margin: 0 auto;
            }
            .ee-faq-eyebrow {
              display: inline-block;
              font-size: 11px;
              font-weight: 800;
              letter-spacing: 0.18em;
              color: #FF6B2C;
              background: rgba(255, 107, 44, 0.12);
              padding: 5px 12px;
              border-radius: 999px;
              margin-bottom: 14px;
            }
            .ee-faq-h {
              font-family: 'Inter Tight', sans-serif;
              font-size: 36px;
              font-weight: 800;
              letter-spacing: -0.025em;
              line-height: 1.08;
              margin: 0 0 10px;
            }
            .ee-faq-sub {
              font-size: 15.5px;
              color: rgba(255,255,255,.65);
              margin: 0 0 32px;
            }
            .ee-faq-list {
              display: flex;
              flex-direction: column;
              gap: 10px;
            }
            .ee-faq-item {
              background: rgba(255,255,255,.04);
              border: 1px solid rgba(255,255,255,.06);
              border-radius: 12px;
              padding: 0;
              transition: background .15s ease, border-color .15s ease;
            }
            .ee-faq-item[open] {
              background: rgba(255,107,44,.06);
              border-color: rgba(255,107,44,.25);
            }
            .ee-faq-q {
              cursor: pointer;
              padding: 16px 20px;
              font-size: 15.5px;
              font-weight: 700;
              color: #fff;
              list-style: none;
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 12px;
              font-family: 'Inter Tight', sans-serif;
            }
            .ee-faq-q::-webkit-details-marker { display: none; }
            .ee-faq-q::after {
              content: '+';
              font-size: 22px;
              font-weight: 400;
              color: #FF6B2C;
              transition: transform .2s ease;
              line-height: 1;
              flex-shrink: 0;
            }
            .ee-faq-item[open] .ee-faq-q::after {
              transform: rotate(45deg);
            }
            .ee-faq-a {
              margin: 0;
              padding: 0 20px 18px;
              font-size: 14.5px;
              line-height: 1.55;
              color: rgba(255,255,255,.78);
            }
            @media (max-width: 600px) {
              .ee-faq { padding: 48px 18px 56px; }
              .ee-faq-h { font-size: 28px; }
              .ee-faq-sub { font-size: 14.5px; margin-bottom: 24px; }
              .ee-faq-q { font-size: 14.5px; padding: 14px 16px; }
              .ee-faq-a { padding: 0 16px 16px; font-size: 14px; }
            }
          `}</style>
        </section>

        {/* ============================= FOOTER ============================= */}
        <footer className="ee-footer">
          <div className="ee-footer-cols">
            <div className="ee-footer-brand">
              <div style={{marginBottom:12}}><EELogo size={26} color="#fff"/></div>
              <p className="ee-footer-desc">Plataforma de análisis estadístico de básquet. Proyecciones y datos en vivo de NBA, Euroliga y 94 ligas, directo a tu Telegram.</p>
            </div>
            <div className="ee-footer-col">
              <h5>Producto</h5>
              <ul>
                <li><a href="#como-funciona">Cómo funciona</a></li>
                <li><a href="#precision">Precisión</a></li>
                <li><a href="#precios">Precios</a></li>
              </ul>
            </div>
            <div className="ee-footer-col">
              <h5>Soporte</h5>
              <ul><li><a href="mailto:soporte@edgeelite.cl">soporte@edgeelite.cl</a></li></ul>
            </div>
            <div className="ee-footer-col">
              <h5>Legal</h5>
              <ul>
                <li><a href="/terminos">Términos y condiciones</a></li>
                <li><a href="/privacidad">Privacidad</a></li>
              </ul>
            </div>
            <div className="ee-footer-aws-col">
              <div className="ee-footer-aws-card">
                <div className="ee-footer-aws-text">
                  <span>powered</span>
                  <span>by</span>
                </div>
                <img src="/landing/aws-logo.png" alt="AWS" className="ee-footer-aws-img"/>
              </div>
            </div>
          </div>
          <div className="ee-footer-disclaimer">Solo mayores de 18 años. Edge Elite es una herramienta de análisis estadístico e informativo: no garantiza resultados y no opera apuestas.</div>
          <div className="ee-footer-copy"><span>© 2026 Edge Elite. Todos los derechos reservados.</span><span>Hecho en Chile 🇨🇱</span></div>
        </footer>

      </div>
    </>
  );
}
